import React from 'react';
import Post from '../Portfolio/index';
import { PortfolioData } from '../interfaces';
import axios from '../const/axios';

export default class Portfolio extends React.Component<{}, {
	posts: PortfolioData[]
}> {

	public state = {
		posts: [] as PortfolioData[]
	}

	async componentDidMount() {
		try {
			let {data} = await axios.get('/portfolio.json?token=' + Math.random().toString(32).slice(2));
			this.setState({posts: data});
		} catch (e) {
			console.error(e);
		}
	}

	render() {
		return (
			<>					
				<div className="intro">
					<h3>
						Below is a collection of artwork I've produced for various events throughout my time at school and university. It is not a complete set, since I tend to employ graphic design techniques for almost every project and presentation I undertake. Instead it is a sequence of 'collections'. I have experience with a variety of programs, including the Adobe Creative Cloud suite and the GNU Image Manipulation Program (GIMP).
					</h3>
				</div>
				{this.state.posts.map(p => {
					return (
						<Post
							key={p.id}
							{...p}
						/>
					)
				})}
			</>
		);
	}
}
